import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { useDispatch, useSelector } from "react-redux";
import { createGroup,updateGroup, resetMode } from "../../reducers/customerTableSlice";
import CustomDialog from "../CustomDialog";
import { Text } from "../Text";
import axiosInstance from "../../api/axios.instance";

function CreateGroup({groupFrom="customers",campCustomerStatus="all", createGrpModule, setCreateGrpModule, toast }) {
  const { mode , selectedGroup, customersInSelectedGroup} = useSelector(state=> state.customerTable);

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");
  const [nameCust, setNameCust] = useState("");
  const [customers, setCustomers] = useState([]);
  const [currPage, setCurrpage] = useState(0);
  const [prevpage, setPrevPage] = useState(-1);
  const [wasLastList, setWasLastList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {  selectedCampaignId,} = useSelector(state => state.dashboard)

  const listInnerRef = useRef();

  const dispatch = useDispatch();

  const hideGroupModule = () =>{
    dispatch(resetMode());
    setCreateGrpModule(false)
  }

  const onSubmit = () => {
    if (nameCust.length === 0) {
      toast.current.show({
        severity: "error",
        detail: "Please enter group name",
      });
      return;
    }
    const data = {
      groupName: nameCust,
      customerIds: Array.from(selectedCustomer, (x) => {
        return x["id"];
      }),
    };
    if(mode === "update"){
        const groupId = selectedGroup.id;
        dispatch(updateGroup({groupId,data}))
        .unwrap()
        .then(res=>{
         hideGroupModule();
          toast.current.show({ severity: "success", detail: "Group update success." });
        })
        .catch(errResponse=>{
          toast.current.show({ severity: "error", detail: errResponse.message});
        })
    }else{
      dispatch(createGroup(data)).then((res) => {
        if (res.error) {
          toast.current.show({ severity: "error", detail: res.error.message });
          return;
        }
        if (res.payload) {
          toast.current.show({ severity: "success", detail: "Group is created" });
          return;
        }
      });

      hideGroupModule();
    } 
  };

  const initFilters1 = () => {
    setFilters1({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      phone: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue1("");
  };

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (Math.floor(scrollTop + clientHeight) === scrollHeight || Math.ceil(scrollTop + clientHeight) === scrollHeight) {
        setCurrpage(currPage + 1);
      }
    }
  };

  useEffect(() => {
    initFilters1();
    if(mode === "update"){
      setNameCust(selectedGroup.groupName)
      axiosInstance.get(`/customer-group/${selectedGroup.id}/customer?page=0&limit=10000`)
      .then(res=>{
        setSelectedCustomer(res.data.rows)
      })
      .catch(err=>console.log(err))
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(prev=>!prev)
      try{

        if(groupFrom == 'campaign'){

         const response = await axiosInstance.get(`campaign/${selectedCampaignId}/customer?page=${currPage}&limit=${20}&status=${campCustomerStatus}`)
 
          setIsLoading(prev=>!prev)

          setCustomers((prevCustomers) => [
            ...prevCustomers,
            ...response.data.customers,
          ]);
     
          if (response.data.customers.length<20) {
            setWasLastList(true);
            return;
          }
         
       }else{
        const  response = await axiosInstance.get(
           `/customer?page=${currPage}&limit=20&isActive=1`
         );
 
         setIsLoading(prev=>!prev)
     
         setCustomers((prevCustomers) => [
          ...prevCustomers,
          ...response.data.rows,
        ]);
         if (response.data.rows.length<20) {
           setWasLastList(true);
           return;
         }

       }
       setPrevPage(currPage);

      }catch(err){
        setIsLoading(prev=>!prev)
        console.log(err.response)
      }

    };
    if (!wasLastList && prevpage !== currPage) {
      fetchData();
    }
  }, [currPage]);

  const renderHeader1 = () => {
    return (
      <span className="p-input-icon-right w-full">
        <InputText
          value={globalFilterValue1}
          onChange={onGlobalFilterChange1}
          placeholder="Search Customers"
          style={{ width: "100%" }}
        />
        <i className="pi pi-search" />
      </span>
    );
  };
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = { ...filters1 };
    _filters1["global"].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  };
  let headerGroup = (
    <ColumnGroup style={{ background: "#EDEDED" }}>
      <Row>
        <Column selectionMode="multiple" />
        <Column header={renderHeader1} colSpan={2} />
      </Row>
    </ColumnGroup>
  );

  return (
    <CustomDialog
      header={mode==="update"?"Update Group":`Create New Group`}
      visible={createGrpModule}
      onHide={hideGroupModule}
    >
      <div className="grid w-full h-full m-0">
        <div
          className={`col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12 mt-5 flex flex-column justify-content-between`}
        >
          <div>
            <div className="card">
              <div
                className="card-container m-2 flex align-items-center justify-content-start border-1 border-round-sm border-dashed border-grey-500"
                style={{ backgroundColor: "#1C738E1A" }}
              >
                <div className="flex-1 m-2 px-3 py-2 flex align-items-center">
                  <Text type={"heading"}>
                    <span style={{ fontSize: "1.6rem" }}>
                      {selectedCustomer.length}{" "}
                    </span>
                  </Text>
                  <Text type={"heading"}>&nbsp;Selected</Text>
                </div>
              </div>
            </div>
            <div className="card">
              <h5 className="m-2">Name of the Group</h5>
              <div className="card-container m-2 flex align-items-center justify-content-start">
                <InputText
                  value={nameCust}
                  onChange={(e) => setNameCust(e.target.value)}
                  placeholder="Enter group name"
                  className="w-12"
                ></InputText>
              </div>
            </div>
          </div>

          <div className="hidden sm:hidden md:hidden xl:flex lg:flex">
            <div className="flex w-4 align-items-center justify-content-center ">
              <Button
                varient="filled"
                label={"Cancel"}
                className="skalebot-button flex w-12 mx-2 mt-2"
                onClick={() => hideGroupModule()}
                style={{ background: "#868686", border: "none" }}
              />
            </div>
            <div className=" flex w-8 align-items-center justify-content-center">
              <Button
                varient="filled"
                label={mode==="update"?"Update":"Save"}
                className="skalebot-button flex w-12 mx-2 mt-2 "
                style={{ background: "#1C738E", border: "none" }}
                onClick={onSubmit}
              />
            </div>
          </div>
        </div>
        <div className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12">
          <div className="flex-1 m-2 text-base mb-2 font-bold pb-1">
            Contacts
          </div>
          <div
            className={`card mt-2 overflow-y-auto `}
            ref={listInnerRef}
            onScroll={onScroll}
            style={{height:"530px"}}
          >
            <DataTable
              value={customers}
              selection={selectedCustomer}
              headerColumnGroup={headerGroup}
              onSelectionChange={(e) => setSelectedCustomer(e.value)}
              filters={filters1}
              globalFilterFields={["name", "phone"]}
              dataKey="id"
              responsiveLayout="scroll"
              scrollable
              className="skalebot-table2 border-round-left-xs"
              loading={isLoading}
            >
              <Column selectionMode="multiple" header={false}  style={{ width: "20%",flex: "none" }}></Column>

              <Column field="name"  style={{ width: "40%" }}></Column>
              <Column field="phone"  style={{ width: "40%" }}></Column>
            </DataTable>
          </div>
          <div className="flex sm:flex md:flex xl:hidden lg:hidden gap-3 sm:flex-nowrap md:flex-nowrap mt-5">
            <div className="w-4">
              <Button
                varient="filled"
                label={"Cancel"}
                className="skalebot-button w-full"
                onClick={() => setCreateGrpModule(false)}
                style={{ background: "#868686", border: "none" }}
              />
            </div>
            <div className="w-8 flex-grow-1">
              <Button
                varient="filled"
                label={mode==="update"?"Update":"Save"}
                className="skalebot-button w-full"
                style={{ background: "#1C738E", border: "none" }}
                onClick={onSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </CustomDialog>
  );
}

export default CreateGroup;
